<section class="filters">
  <mat-progress-bar
    mode="indeterminate"
    *ngIf="loading || searching"
  ></mat-progress-bar>
  <section class="title">
    <h2>Event Filters</h2>
    <button mat-icon-button (click)="openHelpDialog()">
      <mat-icon>help</mat-icon>
    </button>
  </section>
  <form [formGroup]="form">
    <!-- Date Range -->
    <mat-form-field>
      <mat-label>Date Range</mat-label>
      <mat-select
        formControlName="dateRange"
        [compareWith]="dateTimeComparator"
      >
        <mat-option
          *ngFor="let option of dateRangeOptions"
          [value]="option.value"
          >{{ option.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- Company Filter -->
    <mat-form-field>
      <mat-label>Company Filter</mat-label>
      <mat-select formControlName="company">
        <mat-form-field class="select-with-search">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="filterCompany($event.target.value)" />
        </mat-form-field>
        <mat-option
          *ngFor="let option of filteredCompaniesOptions"
          [value]="option.id"
          >{{ option.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- Company Index -->
    <mat-form-field>
      <mat-label>Company Index</mat-label>
      <mat-select formControlName="index">
        <mat-form-field class="select-with-search">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="filterIndex($event.target.value)" />
        </mat-form-field>
        <mat-option
          *ngFor="let option of filteredIndexOptions"
          [value]="option.id"
          >{{ option.friendly }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </form>

  <section class="query-filter-display" *ngIf="queryFilterValue">
    <mat-form-field>
      <textarea matInput [value]="queryFilterValue" disabled="true"></textarea>
    </mat-form-field>
  </section>

  <section class="action-container">
    <div>
      <button
        mat-stroked-button
        color="primary"
        (click)="performSearch()"
        [disabled]="loading || searching || form.invalid"
      >
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button
        mat-stroked-button
        color="primary"
        (click)="openQueryBuilder()"
        [disabled]="loading || searching || form.invalid"
      >
        <mat-icon>build</mat-icon>
        Query Builder
      </button>
    </div>
    <p>Time to refresh: {{ refreshInterval }}</p>
  </section>
</section>
